<template>
    <ion-page>
        <div>
            <div v-if="error!==''" class="visits_error ion-text-center">{{ error }}</div>
            <ion-grid>
            <ion-row>      
                <ion-col>
                    <ion-button class="cancel_button" size="small" v-on:click="onCancel" >Cancel</ion-button>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-item>
                        <ion-label>All Users</ion-label>
                        <ion-toggle
                            @ionChange="getAllVisitsToggle"
                            value="true"
                            :checked="getAllVisits">
                        </ion-toggle>   
                    </ion-item>     
                </ion-col>    
            </ion-row>    
            </ion-grid>
        </div>

        <div class="results"> 
            <!-- <ion-list>
                <ion-item v-for="(visit, index) in visits" :key="visit.flvis_id">
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                {{index}} {{ visit.flvis_code }}
                            </ion-col>
                        </ion-row>
                    </ion-grid>            
                </ion-item>
            </ion-list>
            -->

            <ion-list>
                <ion-item v-for="(visit, index) in visitsList" :key="visit.flvis_id">
                    <ion-grid>
                        <ion-row>
                            <ion-col size="7">
                                <div style="display: flex; flex-wrap: wrap">
                                <ion-col size="12" size-md="4">
                                    <ion-label>Code: </ion-label>
                                    {{ visit.flvis_code }}
                                </ion-col>
                                <ion-col size="12" size-md="4">                    
                                    <div v-for="(person) in visit.persons" :key="person.flvisp_id">
                                    <span v-if="person.flvisp_company!=''" ><ion-label>Company: </ion-label>{{ person.flvisp_company }}</span>
                                    <span v-if="person.flvisp_first_name!=''" ><ion-label>First: </ion-label>{{ person.flvisp_first_name }}</span>
                                    <span v-if="person.flvisp_last_name!=''" ><ion-label>Last: </ion-label>{{ person.flvisp_last_name }}</span>
                                    <span v-if="person.flvisp_phone!=''" ><ion-label>Phone: </ion-label>{{ person.flvisp_phone }}</span>
                                    <span v-if="person.flvisp_email!=''" ><ion-label>Email: </ion-label>{{ person.flvisp_email }}</span>
                                    <span v-if="person.flvisp_website!=''" ><ion-label>Web: </ion-label>{{ person.flvisp_website }}</span>
                                    <span v-if="person.flvisp_images!=''" ><ion-label>Card was Added</ion-label></span>
                                    </div>
                                </ion-col>                  
                                </div>
                            </ion-col>
                            <ion-col size="5" class="ion-text-right"> 
                                <div style="display: flex; flex-wrap: wrap">
                                <ion-col size="12" size-md="4">
                                    <ion-button size="small" @click="select_visit(index)" >
                                        Select
                                    </ion-button>
                                </ion-col>
                                <ion-col size="12" size-md="4">                    
                                    <span v-if="visit.flvis_started!='' && visit.flvis_ended!=''">
                                    <ion-label>Started: </ion-label>
                                    {{ visit.flvis_started }}<br>
                                    <ion-label>Finished: </ion-label>
                                    {{ visit.flvis_ended }}
                                    </span>
                                    <span v-if="visit.flvis_started!='' && visit.flvis_ended==''">
                                    <ion-label>Started: </ion-label>
                                    {{ visit.flvis_started }}<br>
                                    </span>
                                    <span>
                                    <ion-label>Started by: </ion-label>
                                    {{ visit.started_by_name }}<br>
                                    </span>
                                </ion-col>
                                </div>                 
                            </ion-col>                
                        </ion-row>
                        <ion-row>
                            <ion-col size="12" size-md="4" class="ion-text-right">
                                <ion-button color="warning" v-if="tearsheet_enabled==true && visit.tearsheet_checked==true" @click="toggle(visit,'T')">Tearsheet</ion-button>
                                <ion-button color="light" v-if="tearsheet_enabled==true && visit.tearsheet_checked!=true" @click="toggle(visit,'T')">No Tearsheet</ion-button>                                          

                                <ion-button color="primary" v-if="memo_enabled==true && visit.memo_checked==true" @click="toggle(visit,'M')">Sample</ion-button>
                                <ion-button color="light" v-if="memo_enabled==true && visit.memo_checked!=true" @click="toggle(visit,'M')">No Sample</ion-button>                                          

                                <ion-button color="success" v-if="quote_enabled==true && visit.quote_checked==true" @click="toggle(visit,'Q')">Quote</ion-button>
                                <ion-button color="light" v-if="quote_enabled==true && visit.quote_checked!=true" @click="toggle(visit,'Q')">No Quote</ion-button>                                          
                            </ion-col>   
                        </ion-row>  
                        <ion-row>
                            <ion-col>
                                <ion-textarea
                                class="floor_sample_item_note"
                                placeholder="Write a note for the item"
                                v-model="visit.item_notes"
                                @keyup="write_note($event, visit)"
                                rows="3"
                                ></ion-textarea>
                            </ion-col>
                        </ion-row>  
                    </ion-grid>

                </ion-item>
            </ion-list>        
        </div>  
    </ion-page>  
</template>

<script>
import { IonPage, IonGrid, IonRow, IonCol, IonButton, IonItem, IonList, IonLabel, modalController, IonToggle } from '@ionic/vue';

export default {
    props : [ 'visits', 'tearsheet_enabled', 'memo_enabled', 'quote_enabled', 'tearsheet_active', 'memo_active', 'quote_active' ],
    components: { IonPage, IonGrid, IonRow, IonCol, IonButton, IonItem, IonList, IonLabel, IonToggle},

    data(){
        return {
            error: '',
            modalController: modalController,
            getAllVisits:false,
            visitsList:[]
        }
    },

    methods: {
        async select_visit(index){
            this.modalController.dismiss(this.visits[index]);
        },
        
        onCancel(){
            this.modalController.dismiss('cancelled');
        },

        toggle(visit,subject) {
            if (subject=='T') {
                if (visit.tearsheet_checked==undefined) {
                visit.tearsheet_checked = false;
                }
                visit.tearsheet_checked = !visit.tearsheet_checked;
            }
            if (subject=='M') {
                if (visit.memo_checked==undefined) {
                visit.memo_checked = false;
                }        
                visit.memo_checked = !visit.memo_checked;
            }
            if (subject=='Q') {
                if (visit.quote_checked==undefined) {
                visit.quote_checked = false;
                }        
                visit.quote_checked = !visit.quote_checked;
            }
        },     

        write_note(event, visit){
            visit.item_notes = event.target.value;
        },

        async getAllVisitsToggle({ detail }) {
            this.getAllVisits = detail.checked;
            
            // request for InProgress visits
            await this.$store.dispatch("visits/request_for_visits", {
                term: '',
                limit: 0,
                offset: 0,
                status: 'InProgress',
                getAllVisits: this.getAllVisits
            });

            var req_error = this.$store.getters["visits/getRequestError"];

            if (req_error != "") {
                this.error = req_error;
            } else {
                this.visitsList = this.$store.getters["visits/getAllVisits"];
                for(let i=0; i<this.visitsList.length; i++){
                    this.visitsList[i].tearsheet_checked = this.tearsheet_active;
                    this.visitsList[i].memo_checked = this.memo_active;
                    this.visitsList[i].quote_checked = this.quote_active;
                    this.visitsList[i].item_notes = '';
                }
            }
        }
    },

    mounted(){
        this.visitsList = this.visits;
    }

}
</script>

<style lang="scss" >

    .results {

        font-size: 0.9em;

        ion-list {
            overflow:scroll; 
            max-height:100vh;
        }

        ion-col {
            font-size: 0.9em;
        }

        .conf-name {
            color: #000;
        }

        ion-row {
            background: #ffffff;
            /*     margin-bottom: 10px; */
            padding: 10px;
            border-left: 10px solid #226391;
            height: auto;
        }

        .no-date {
            font-style: italic;
        }

        a {
            text-decoration: none;
        }

        ion-grid {
            height: auto;
        }

        ion-item {
            border: none;
            padding: 0px;
        }

        .item-native {
            padding: 0px;
            padding-inline: 0px;
        }

        .item-inner {
            padding: 0px;
            padding-inline: 0px;
            border: none;
        }

        ion-label {
            font-size: 0.8em;
            font-weight: bold;
            color: #444;
        }
    }

    .cancel_button {
        float:right;
    }

    .floor_sample_item_note {
        width: 100%;
        height: 80px;
        background: #efefef;
        margin-top: 0px;
        border-radius: 8px;
        border: 1px solide #333;
        padding: 3px 8px !important;
    }

    .visits_error {
       color: red;
        font-size: 15px;
    }

</style>